// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"01ed2075","455":"af2115ca","977":"37d9e8f3"}[chunkId] + ".chunk.js";
};